import React from "react"
import { Box } from "@chakra-ui/react"
import { Control } from "react-hook-form"
import ImageUpload from "components/ReactHookForm/ImageUpload"
import { PassBuilderDescription } from "./PassBuilderTypography"
import {
  PassBuilderFieldHeading,
  PlatformHint,
  PlatformStatus,
} from "./PassBuilderLayout"
import PassBuilderUploadDropzone from "./PassBuilderUploadDropzone"
import { WalletPassBuilderFormValues } from "./walletPassBuilderTypes"

type Props = {
  title: string
  name: keyof WalletPassBuilderFormValues
  control: Control<WalletPassBuilderFormValues, object>
  platform: PlatformHint
  status?: PlatformStatus
  description: string
  dropLabel: string
  dropWidth: number
  dropHeight: number
  imageUrl?: string
  isUploading?: boolean
  /** "cover" for full-bleed images (banners/heroes), "contain" for logos. */
  imageFit?: "contain" | "cover"
  /** Restrict the file picker, e.g. "image/png" for transparent logos. */
  accept?: string
  /** False for slots the pass always fills, which offer Upload only. */
  isRemovable?: boolean
}

const PassBuilderBrandingField = ({
  title,
  name,
  control,
  platform,
  status,
  description,
  dropLabel,
  dropWidth,
  dropHeight,
  imageUrl,
  isUploading,
  imageFit = "contain",
  accept,
  isRemovable,
}: Props) => (
  <Box w="full" minW={0}>
    <PassBuilderFieldHeading
      title={title}
      platform={platform}
      status={status}
    />
    <PassBuilderDescription>{description}</PassBuilderDescription>
    <ImageUpload
      name={name}
      control={control}
      imageUrl={imageUrl}
      imageWidth="full"
      imageHeight="full"
      imageFit={imageFit}
      hideImageBorder
      accept={accept}
      Component={({ imagePreview, fileInputRef, onRemove }) => (
        <PassBuilderUploadDropzone
          dropLabel={dropLabel}
          width={dropWidth}
          height={dropHeight}
          imageUrl={imageUrl}
          imageFit={imageFit}
          imagePreview={imagePreview}
          onUpload={() => fileInputRef.current?.click()}
          onRemove={onRemove}
          isUploading={isUploading}
          isRemovable={isRemovable}
        />
      )}
    />
  </Box>
)

export default PassBuilderBrandingField
